export const namespaced = true

export const state = {
  routing: false
}

export const getters = {
  routing: state => state.routing
}

export const mutations = {
  SET_ROUTING (state, data) {
    state.routing = data
  }
}

export const actions = {
  setRouting ({ commit, dispatch }, routing) {
    commit('SET_ROUTING', routing)
  }
}
